import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import TextareaAutosize from 'react-autosize-textarea';

import './style.scss';

class TextArea extends Component {

  getTextAreaElement() {
    if (this.props.isAutosized) {
      return this.refs.textarea.getTextareaDOMNode();
    }

    return this.refs.textarea;
  }

  focus() {
    this.getTextAreaElement().focus();
  }

  getSelectionStart() {
    return this.getTextAreaElement().selectionStart;
  }

  setCaretPosition(position) {
    this.refs.textarea.selectionStart = position;
    this.refs.textarea.selectionEnd = position;
  }

  render() {
    const { isExpanded, isAutosized, hasMediumHeight, ...otherProps } = this.props;

    const className = classnames(
      'TextArea',
      {
        'is-expanded': isExpanded,
        'is-autosized': isAutosized,
        'has-medium-height': hasMediumHeight
      }
    );

    return (
      this.props.isAutosized
        ? <TextareaAutosize ref="textarea" className={className} {...otherProps} />
        : <textarea ref="textarea" className={className} {...otherProps} />
    );
  }
}

TextArea.propTypes = {
  isExpanded: PropTypes.bool,
  isAutosized: PropTypes.bool,
  hasMediumHeight: PropTypes.bool
};

export default TextArea;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/TextArea/index.js
 **/